define([
  'axios',
  'js-cookie',
], (axios, jscookie) => {

  class Service {
    constructor(api) {
      this.api = api;

      this.shownPopups = [];
      this.conversions = [];
      this.features = {};
    }

    post(relativeUrl, extraData) {
      const url = `${this.api.properties.sumoUrl}${relativeUrl}`;
      const data = {
        site_id: this.api.properties.siteId,
      };

      return axios.post(url, {...data, ...extraData}, {
        withCredentials: false,
        headers: {
          'X-Sumo-Auth': this.getCookie('__smToken'),
        },
      });
    }

    get(relativeUrl, extraParams) {
      const url = `${this.api.properties.sumoUrl}${relativeUrl}`;
      const params = {
        site_id: this.api.properties.siteId,
      };

      return axios.get(url, {
        withCredentials: false,
        params: { ...params, ...extraParams },
        headers: {
          'X-Sumo-Auth': this.getCookie('__smToken'),
        },
      });
    }

    setCookie(cookieName, cookieValue, cookieOpts) {
      jscookie.set(cookieName, cookieValue, cookieOpts);
    }

    getCookie(cookieName) {
      return jscookie.get(cookieName);
    }

    delCookie(cookieName) {
      return jscookie.remove(cookieName);
    }

    getJSONCookie(cookieName) {
      return jscookie.getJSON(cookieName);
    }

    addEvent(el, event, handler) {
      if (!el) { return; }
      if (el.attachEvent) {
        el.attachEvent('on' + event, handler);
      } else if (el.addEventListener) {
        el.addEventListener(event, handler, true);
      } else {
        // $FlowIgnore: Doesn't think elements are indexable
        el['on' + event] = handler;
      }
    }

    removeEvent(el, event, handler) {
      if (!el) { return; }
      if (el.detachEvent) {
        el.detachEvent('on' + event, handler);
      } else if (el.removeEventListener) {
        el.removeEventListener(event, handler, true);
      } else {
        //$FlowIgnore: Doesn't think elements are indexable
        el['on' + event] = null;
      }
    }

    fetchFeatures() {
      const siteId = this.api.properties.siteId;
      if (!siteId) return Promise.reject(new Error('No siteId on fetchFeatures.'));
      return this.get(`/api/site/${siteId}/features`)
        .then(({ data }) => {
          const noFeaturesError = new Error('Error fetching features.');
          if (!data) throw noFeaturesError;
          const { featuresMap } = data;
          if (!featuresMap) throw noFeaturesError;
          this.features = featuresMap || {};
          return this.features;
        })
        .catch((error) => {
          console.error(error);
          return Promise.reject(error);
        });
    }
  }

  return Service;
});
